import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDomesticLocation: {},
  selectedIntLocation: {},
  countryListData: [],
  cityListDataPDP: [],
  cityListData: [],
  visitedCountry: null,
  isShowMobileLocationLock: false,
  isShowDesktopLocationLock: false,
  isShowMobileLocationLockDrawer: false,
  isHideSavedAddresses: false,
  savedAddressUserName: null,
  onFocusChangeFromTextfield: false,
  selectedCountryFromList: "india",
  configData: {},
  mandateErrorClick: false,
  isShowCartEmpty: false,
  selectedDomesticLocationForCart: {},
  selectedIntLocationForCart: {},
  unserviceableCartItems: [],
  isClearCartDueToCountryChange: false,
  pendingCountryChange: null,
  shouldClearLocationLockInput: false,
  skipCartValidationOnce: false,
  /** After ClearCart Change Location clears a cross-catalog cart, retry ATC/Buy Now. */
  shouldRetryAddToCartAfterClear: false,
  pendingMandatoryEmailEdit: null,
  /** Location picked in the add / edit address map form: { lat, long, accuracyType } for serviceability APIs. */
  mapFormLocation: null,
};

const LocationLockSlice = createSlice({
  name: "locationLockSlice",
  initialState,
  reducers: {
    getInternationalCityListPDP: () => {},

    setMapFormLocation: (state, action) => {
      state.mapFormLocation = action.payload;
    },

    clearMapFormLocation: (state) => {
      state.mapFormLocation = null;
    },

    setInternationalCityListDataPDP: (state, action) => {
      return {
        ...state,
        cityListDataPDP: action.payload,
      };
    },
    getInternationalCityList: (state) => {
      return {
        ...state,
      };
    },
    setInternationalCityListData: (state, action) => {
      return {
        ...state,
        cityListData: action.payload,
      };
    },

    setSelectedCountryAction: (state, action) => {
      return {
        ...state,
        visitedCountry: action.payload,
      };
    },

    setSelectedDomesticLocation: (state, action) => {
      return {
        ...state,
        selectedDomesticLocation: action.payload,
      };
    },

    setSelectedIntLocation: (state, action) => {
      return {
        ...state,
        selectedIntLocation: action.payload,
      };
    },
    setSelectedCountryFromList: (state, action) => {
      return {
        ...state,
        selectedCountryFromList: action.payload,
      };
    },
    setIsShowMobileLocationLockAction: (state, action) => {
      return {
        ...state,
        isShowMobileLocationLock: action.payload,
      };
    },
    setIsShowDesktopLocationLockAction: (state, action) => {
      return {
        ...state,
        isShowDesktopLocationLock: action.payload,
      };
    },
    setIsShowMobileLocationLockDrawerAction: (state, action) => {
      return {
        ...state,
        isShowMobileLocationLockDrawer: action.payload,
      };
    },
    setIsHideSavedAddresses: (state, action) => {
      return {
        ...state,
        isHideSavedAddresses: action.payload,
      };
    },
    setIsSavedAddressUserName: (state, action) => {
      return {
        ...state,
        savedAddressUserName: action.payload,
      };
    },

    getCountryListsData: () => {},

    setCountryListData: (state, action) => {
      return {
        ...state,
        countryListData: action.payload,
      };
    },
    onFocusRequestFromTextfield: (state, action) => {
      return {
        ...state,
        onFocusChangeFromTextfield: action.payload,
      };
    },
    getLocationLockConfigDataAction: (state) => {
      return {
        ...state,
      };
    },
    setLocationLockConfigDataAction: (state, action) => {
      return {
        ...state,
        configData: action.payload,
      };
    },
    setMandateErrorAction: (state, action) => {
      return {
        ...state,
        mandateErrorClick: action.payload,
      };
    },
    setIsShowCartEmpty: (state, action) => {
      return {
        ...state,
        isShowCartEmpty: action.payload,
      };
    },
    setSelectedDomesticLocationForCart: (state, action) => {
      return {
        ...state,
        selectedDomesticLocationForCart: action.payload,
      };
    },
    setSelectedIntLocationForCart: (state, action) => {
      return {
        ...state,
        selectedIntLocationForCart: action.payload,
      };
    },
    setUnserviceableCartItems: (state, action) => {
      return {
        ...state,
        unserviceableCartItems: Array.isArray(action.payload) ? action.payload : [],
      };
    },
    setIsClearCartDueToCountryChange: (state, action) => {
      return {
        ...state,
        isClearCartDueToCountryChange: Boolean(action.payload),
      };
    },
    setPendingCountryChange: (state, action) => {
      return {
        ...state,
        pendingCountryChange: action.payload || null,
      };
    },
    setShouldClearLocationLockInput: (state, action) => {
      return {
        ...state,
        shouldClearLocationLockInput: Boolean(action.payload),
      };
    },
    setSkipCartValidationOnce: (state, action) => {
      return {
        ...state,
        skipCartValidationOnce: Boolean(action.payload),
      };
    },
    setShouldRetryAddToCartAfterClear: (state, action) => {
      return {
        ...state,
        shouldRetryAddToCartAfterClear: Boolean(action.payload),
      };
    },
    setPendingMandatoryEmailEdit: (state, action) => {
      return {
        ...state,
        pendingMandatoryEmailEdit: action.payload || null,
      };
    },
  },
});

export default LocationLockSlice.reducer;
export const {
  getInternationalCityListPDP,
  setInternationalCityListDataPDP,
  getInternationalCityList,
  setInternationalCityListData,
  setSelectedDomesticLocation,
  setSelectedCountryAction,
  setSelectedIntLocation,
  setIsShowMobileLocationLockAction,
  setIsShowDesktopLocationLockAction,
  setIsShowMobileLocationLockDrawerAction,
  setIsHideSavedAddresses,
  setIsSavedAddressUserName,
  getCountryListsData,
  setCountryListData,
  onFocusRequestFromTextfield,
  getLocationLockConfigDataAction,
  setLocationLockConfigDataAction,
  setSelectedCountryFromList,
  setMandateErrorAction,
  setIsShowCartEmpty,
  setSelectedDomesticLocationForCart,
  setSelectedIntLocationForCart,
  setUnserviceableCartItems,
  setIsClearCartDueToCountryChange,
  setPendingCountryChange,
  setShouldClearLocationLockInput,
  setSkipCartValidationOnce,
  setShouldRetryAddToCartAfterClear,
  setPendingMandatoryEmailEdit,
  setMapFormLocation,
  clearMapFormLocation,
} = LocationLockSlice.actions;
